import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Skeleton from '@mui/material/Skeleton';
import Card from '@mui/material/Card';

const MetricSkeleton = () => (
  <Card className="mb-4" style={{ padding: '1rem' }}>
    <Skeleton variant="text" width="40%" height={20} />
    <Skeleton variant="text" width="60%" height={32} />
    <Skeleton variant="text" width="30%" height={16} />
  </Card>
);

const ChartSkeleton = () => (
  <Card className="mb-4" style={{ padding: '1rem', height: 320 }}>
    <Skeleton variant="rectangular" height="100%" />
  </Card>
);

const TableSkeleton = () => (
  <Card className="mb-4" style={{ padding: '1rem' }}>
    <Skeleton variant="rectangular" height={56} />
    {Array.from({ length: 5 }).map((_, idx) => (
      <Skeleton key={idx} variant="rectangular" height={48} sx={{ mt: 1 }} />
    ))}
  </Card>
);

const DashboardSkeleton = () => {
  return (
    <div>
      {/* Métricas */}
      <Row className="mb-4">
        {Array.from({ length: 4 }).map((_, idx) => (
          <Col xl={3} md={6} className="mb-4" key={idx}>
            <MetricSkeleton />
          </Col>
        ))}
      </Row>
      <Row className="mb-4">
        {Array.from({ length: 4 }).map((_, idx) => (
          <Col xl={3} md={6} className="mb-4" key={idx}>
            <MetricSkeleton />
          </Col>
        ))}
      </Row>

      {/* Charts */}
      <Row className="mb-4">
        <Col xl={8} className="mb-4">
          <ChartSkeleton />
        </Col>
        <Col xl={4} className="mb-4">
          <ChartSkeleton />
        </Col>
      </Row>

      {/* Table */}
      <TableSkeleton />
    </div>
  );
};

export default DashboardSkeleton;
